<template>
  <div class="fav-item-container">
    <!-- 顶部导航栏 -->
    <div class="header-bar">
      <div class="left" @click="$router.go(-1)">
        <i class="el-icon-arrow-left" />
        <span class="nav-title">{{ albumInfo.albumName || '收藏夹详情' }}</span>
      </div>
      <!-- ★ 新增：播放收藏夹按钮 -->
      <div class="right" @click="playAlbum">
        <i class="el-icon-video-play" /> 播放
      </div>
    </div>

    <!-- 内容滚动区域 -->
    <div class="main-scroll-content">
      <!-- 收藏夹基础信息头 -->
      <div v-if="albumInfo.albumId" class="album-header-card">
        <img :src="albumInfo.coverUrl" class="album-bg-cover" alt="cover">
        <div class="album-mask-info">
          <h2>{{ albumInfo.albumName }}</h2>
          <p>{{ albumInfo.total || 0 }} 个内容 · 创建于 {{ albumInfo.createAt || '近期' }}</p>
        </div>
      </div>

      <!-- 视频双列网格列表 -->
      <div v-if="videoList.length > 0" class="video-grid">
        <div
          v-for="(item, index) in videoList"
          :key="item.videoId + '_' + index"
          class="video-card"
          @click="openVideoDetail(item)"
        >
          <div class="cover-wrapper">
            <img :src="item.coverUrl" class="video-cover" alt="cover">

            <!-- 横竖屏图标标识 -->
            <span class="orientation-tag">
              <i :class="item.horizontal ? 'el-icon-monitor' : 'el-icon-mobile-phone'" />
            </span>

            <span v-if="item.duration" class="duration-tag">{{ item.duration }}</span>
          </div>

          <div class="video-info">
            <h4 class="title">{{ item.title }}</h4>
            <div class="user-info">
              <div class="author-detail">
                <img :src="item.user.avatarUrl" class="avatar" alt="avatar">
                <span class="username">{{ item.user ? item.user.screenName : '匿名用户' }}</span>
              </div>
              <div class="more-btn" @click.stop="openMoreDialog(item)">
                <i class="el-icon-more" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 空状态 -->
      <div v-else-if="!loading" class="empty-state">
        <i class="el-icon-video-camera" />
        <p>该收藏夹内还没有任何视频~</p>
      </div>

      <!-- 底部加载状态 / 加载更多按钮 -->
      <div v-if="videoList.length > 0" class="load-status-bar">
        <el-button
          v-if="hasNext"
          type="text"
          :loading="loading"
          @click="loadMore"
        >
          {{ loading ? '加载中...' : '点击加载更多' }}
        </el-button>
        <div v-else class="no-more-wrap">
          <span>— 没有更多视频了 —</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAlbumItems } from '@/api/vod'

export default {
  name: 'MyFavItemMobile',
  data() {
    return {
      albumId: null,
      albumInfo: {},
      videoList: [],
      pn: 1,
      hasNext: false,
      loading: false
    }
  },
  created() {
    this.albumId = this.$route.params.id
    this.getData()
  },
  methods: {
    getData() {
      if (this.loading) return
      this.loading = true

      const queryInfo = {
        albumId: this.albumId,
        pn: this.pn
      }

      getAlbumItems(queryInfo).then(resp => {
        if (resp && resp.code === 0 && resp.data) {
          const { albumInfo, videoList } = resp.data
          if (albumInfo) {
            this.albumInfo = albumInfo
          }
          if (videoList && videoList.list) {
            this.videoList = [...this.videoList, ...videoList.list]
            this.hasNext = videoList.hasNext || false
          }
        } else {
          this.$message.warning((resp && resp.msg) || '获取收藏夹内容失败')
        }
      }).catch(err => {
        console.error(err)
      }).finally(() => {
        this.loading = false
      })
    },
    loadMore() {
      if (this.hasNext) {
        this.pn++
        this.getData()
      }
    },
    openVideoDetail(item) {
      this.$router.push({ path: '/video/' + item.videoId })
    },
    openMoreDialog(item) {
      this.$message.info(`更多操作：${item.title}`)
    },
    // ★ 点击播放整个收藏夹
    playAlbum() {
      if (this.videoList.length === 0) {
        return this.$message.warning('收藏夹内暂无视频可播放')
      }
      this.$router.push({ path: '/playlist/play/' + this.albumId })
    }
  }
}
</script>

<style scoped lang="scss">
.fav-item-container {
  min-height: 100vh;
  background-color: #f7f8fa;
  padding-top: 50px;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.header-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  z-index: 100;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);

  .left {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 500;
    color: #303133;
    cursor: pointer;
    max-width: 75%;

    i { font-size: 18px; flex-shrink: 0; }

    .nav-title {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .right {
    font-size: 13px;
    color: #fb7299;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    font-weight: 500;
    background-color: #fce4ec;
    padding: 4px 10px;
    border-radius: 14px;

    i { font-size: 14px; }
  }
}

.main-scroll-content {
  padding: 12px;
}

/* 收藏夹头部信息卡片 */
.album-header-card {
  position: relative;
  width: 100%;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);

  .album-bg-cover {
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: brightness(0.6);
  }

  .album-mask-info {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 15px;
    color: #ffffff;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, transparent 100%);

    h2 {
      font-size: 16px;
      margin: 0 0 4px 0;
      font-weight: bold;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    p {
      font-size: 11px;
      color: rgba(255, 255, 255, 0.8);
      margin: 0;
    }
  }
}

/* 视频双列网格列表 */
.video-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .video-card {
    width: 48.5%;
    background-color: #ffffff;
    border-radius: 8px;
    margin-bottom: 12px;
    overflow: hidden;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
    display: flex;
    flex-direction: column;
    cursor: pointer;

    .cover-wrapper {
      position: relative;
      width: 100%;
      padding-top: 66.66%;
      background-color: #f0f2f5;

      .video-cover {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .orientation-tag {
        position: absolute;
        top: 6px;
        left: 6px;
        background-color: rgba(0, 0, 0, 0.6);
        color: #ffffff;
        font-size: 12px;
        width: 22px;
        height: 22px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        backdrop-filter: blur(2px);

        i { font-size: 13px; }
      }

      .duration-tag {
        position: absolute;
        bottom: 6px;
        right: 6px;
        background-color: rgba(0, 0, 0, 0.7);
        color: #ffffff;
        font-size: 10px;
        padding: 2px 5px;
        border-radius: 3px;
      }
    }

    .video-info {
      padding: 8px 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;

      .title {
        font-size: 13px;
        font-weight: 500;
        color: #303133;
        margin: 0 0 8px 0;
        line-height: 1.4;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .user-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 11px;
        color: #909399;

        .author-detail {
          display: flex;
          align-items: center;
          overflow: hidden;
          max-width: 75%;

          .avatar {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            margin-right: 4px;
            object-fit: cover;
            flex-shrink: 0;
          }

          .username {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .more-btn {
          padding: 2px 4px;
          cursor: pointer;
          color: #909399;

          i { font-size: 14px; font-weight: bold; }
        }
      }
    }
  }
}

.load-status-bar {
  text-align: center;
  padding: 10px 0 20px;
  font-size: 13px;

  .no-more-wrap {
    color: #c0c4cc;
    font-size: 12px;
  }
}

.empty-state {
  text-align: center;
  padding-top: 100px;
  color: #909399;

  i { font-size: 48px; margin-bottom: 10px; color: #dcdfe6; }
  p { font-size: 14px; margin: 0; }
}
</style>
